module.exports = __webpack_public_path__ + "img/4.0ae23e57.jpg";